<template>
  <div class="artcle-container">
    <Header />
    <div class="search-params">
      <div class="container">
        <div class="search-input">
          <el-input placeholder="输入关键词" v-model="newParams.searchContent"> </el-input>
          <el-button @click="handleSearch" v-pointerReClick>查询</el-button>
        </div>
        <div class="search-hot">
          <div>搜索热词</div>
          <div class="hot" v-for="(item,index) in searchHot" :key="index" @click="handleHot(item)">{{item}}</div>
        </div>
      </div>
    </div>
    <div class="search-result">
      <div class="container">
        <div class="new-artcle">
          <div class="title">最新文章</div>
          <div
            class="new-item"
            @click="handleDetail(item.id)"
            v-for="item in newList"
            :key="item.id"
          >
            <div class="left-img">
              <img :src="item.image" alt="" />
            </div>
            <div class="right-txt">
              <div class="headline">{{ item.title }}</div>
              <div class="txt">
                {{ item.preview }}
              </div>
              <div class="time">{{ item.createDate }}</div>
            </div>
          </div>
        </div>
        <hot-search :hotList="hotList" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { getArticlePage, getPopularArticles, getPopularWords } from '@/api/artcle.js'
/* import { getItem } from '@/utils/storage.js' */
import Header from '@/components/Header/index.vue'
import HotSearch from './components/hot-search.vue'
import Footer from '@/components/Footer/index.vue'
export default {
  name: 'artclePage',
  components: {
    Header,
    HotSearch,
    Footer
  },
  props: {},
  data() {
    return {
      newParams: {
        pageNo: 1,
        pageSize: 10,
        searchContent: '',
      },
      newList: [],
      hotList: [],
      searchHot: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getArticlePage()
    this.getPopularArticles()
    this.getPopularWords()
  },
  methods: {
    async getArticlePage() {
      let res = await getArticlePage(this.newParams)
      if (res.success) {
        this.newList = res.data.data
      }
    },
    async getPopularArticles() {
      let res = await getPopularArticles()
      if (res.success) {
        this.hotList = res.data
      }
    },
    async getPopularWords() {
      let res = await getPopularWords()
      if (res.success) {
        this.searchHot = res.data
      }
    },
    async handleSearch() {
      /* if (!getItem('userInfo')) {
        this.$eventBus.$emit('openLoginDV')
        return false
      } */
      this.getArticlePage()
    },
    handleHot(val) {
      this.newParams.searchContent = val
      this.handleSearch()
    },
    handleDetail(id) {
      this.$router.push({
        path: '/artcle',
        query: {
          id,
          type: 1
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.artcle-container {
  position: relative;
  width: 100%;
  padding-top: 80px;
  .search-params {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 180px;
    background: linear-gradient(-64deg, #346afb, #5187fb);
    margin-bottom: 42px;
    .container {
      width: 1000px;
    }
    .search-input {
      display: flex;
      margin-bottom: 10px;
      .el-input {
        width: 880px;
        ::v-deep.el-input__inner {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .el-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 120px;
        color: #fff;
        background-color: #71A0FF;
        border: 1px solid #71A0FF;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        font-size: 14px;
        font-weight: 400;
      }
    }
    .search-hot {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      > div {
        margin-right: 10px;
      }
      .hot {
        padding: 4px 8px;
        color: #000;
        background-color: #eef5ff;
        border-radius: 13px;
        cursor: pointer;
      }
    }
  }
  .search-result {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 32px;
    .container {
      display: flex;
      justify-content: space-between;
      width: 1200px;
    }
    .new-artcle {
      width: 750px;
      .title {
        background: url('../../assets/artcle/new-artcle.png') no-repeat 0 8px;
        background-size: 30px 24px;
        padding-left: 42px;
        font-size: 28px;
        font-weight: 500;
        color: #24232f;
        margin-bottom: 38px;
      }
      .new-item {
        display: flex;
        margin-bottom: 30px;
        cursor: pointer;
        .left-img {
          img {
            width: 200px;
            height: 140px;
          }
          margin-right: 20px;
        }
        .right-txt {
          position: relative;
          .headline {
            padding-top: 6px;
            font-size: 20px;
            font-weight: 500;
            color: #24232f;
          }
          .txt {
            height: 56px;
            font-size: 14px;
            font-weight: 400;
            color: #767d8f;
            line-height: 28px;
            margin: 10px 0;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .time {
            position: absolute;
            left: 0;
            bottom: 0;
            font-size: 12px;
            font-weight: 400;
            color: #767d8f;
            line-height: 32px;
          }
        }
      }
    }
  }
}
</style>
